/*
 * PDP: hide the Zendesk launcher at mobile width.
 *
 * The chat bubble is a fixed, bottom-corner element, so on a phone it lands on
 * top of the PDP's sticky add-to-cart bar (snippets/forcast-sticky-atc.liquid,
 * position: fixed along the bottom edge). The theme's own stand-in launcher
 * (snippets/forcast-live-chat-launcher.liquid) is kept off that corner by CSS;
 * this hides Zendesk's launcher once the widget is loaded
 * (assets/forcast-live-chat.js). Loaded only from
 * sections/product-information.liquid, so the widget is untouched on every
 * other template.
 *
 * The widget's own show/hide API is used rather than a CSS rule: Zendesk
 * injects the launcher as an iframe carrying its own inline styles, and inline
 * styles can only be beaten with !important (AGENTS.md §12 forbids it).
 */
(function forcastHideSupportWidget() {
  const mobile = window.matchMedia('(max-width: 749px)');
  let hiddenHere = false;

  /* Zendesk ships two widgets behind one global — messaging answers to
     'messenger', the classic Web Widget to 'webWidget' — and which one a store
     runs is an admin setting, not something the theme can read. Both are sent;
     the one this store is not running rejects the command, and must not stop
     the other from being sent. */
  const command = (action) => {
    ['messenger', 'webWidget'].forEach((api) => {
      try {
        window.zE(api, action);
      } catch (error) {
        /* Not this store's widget flavour — the other call is the live one. */
      }
    });
  };

  const apply = () => {
    if (mobile.matches) {
      command('hide');
      hiddenHere = true;
    } else if (hiddenHere) {
      /* Only ever undo our own hide, so a widget that is hidden for some other
         reason (business hours, a shopper dismissing it) stays hidden. */
      command('show');
      hiddenHere = false;
    }
  };

  const start = () => {
    apply();
    mobile.addEventListener('change', apply);
  };

  /* zE only exists once assets/forcast-live-chat.js has loaded Zendesk's
     snippet. On most visits that never happens, so this waits for the event
     the loader sends rather than polling for it. */
  if (typeof window.zE === 'function') start();
  else document.addEventListener('forcast:live-chat:loaded', start, { once: true });
})();
